import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, switchMap, takeUntil, tap, timer } from 'rxjs';

@Directive({
  selector: '[bsMouseHold]',
})
@UntilDestroy()
export class MouseHoldDirective {
  @Input('bsMouseHold') tick!: number | string;
  @Input() delayHold!: number | string;

  private readonly $stop = new Subject<void>();
  private readonly $start = new Subject<void>();

  @Output() mouseHold = new EventEmitter<number>();
  @Output() mouseholdstart = new EventEmitter<void>();
  @Output() mouseholdend = new EventEmitter<void>();

  ngOnInit() {
    this.$start
      .pipe(
        tap(() => this.mouseholdstart.emit()),
        switchMap(() =>
          timer(+this.delayHold || 500, +this.tick).pipe(
            takeUntil(this.$stop.pipe(tap(() => this.mouseholdend.emit())))
          )
        ),
        untilDestroyed(this)
      )
      .subscribe((tick) => this.mouseHold.emit(tick));
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown($event: { button: number }) {
    if ($event.button === 0) {
      this.$start.next();
    }
  }

  @HostListener('mouseup')
  onMouseUp() {
    this.$stop.next();
  }
}
